<div class="logos" fxLayout="row" fxLayoutAlign="space-around center" >
  <img class="gptw" src="assets/images/icons/gptw_100.png" alt="">
  <img class="logoNorma" src="assets/images/norm35/GO_NORM35.png" alt="">
  <img class="logoCliente" src="{{logo}}" alt="">
  </div>

  <div fxLayout="row" fxLayoutAlign="center center" >
    <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}" class="textoNorma" >{{'SECCIONES.INTRODUCCION.TITULO' | translate}}</h1>
    </div>
